import Vue from 'vue';

export async function apartmentsLocationsSearchData(context: Vue) {
	const [locations, locationStats] = await Promise.all([
		context.$locationService.fetchLocations(),
		context.$locationService.fetchLocationStats({
			includeLayoutStats: true
		})
	]);

	return {
		locations,
		locationStats
	};
}
